var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tidal-icon',{class:['block', 'icon', ("icon--" + _vm.type)],attrs:{"icon":_vm.iconSvg,"size":"medium"}})}
var staticRenderFns = []

export { render, staticRenderFns }